import Styled from 'styled-components';

export const Container = Styled.div``;